(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nu-expandable"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const triggers = document.querySelectorAll('.nu-expandable-text__toggle');
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        const parentSection = document.getElementById(trigger.getAttribute('aria-controls'));

        if (isOpen) {
          parentSection.classList.remove('open');
          trigger.setAttribute('aria-expanded', 'false');
        } else {
          parentSection.classList.add('open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
